import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import {
  getSahayApplicationMasterReport,
  getSahaySubTypeList,
  getSahayTypeList,
} from "../../../../redux/features/AddService";
import { useSelector } from "react-redux";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import { useReactToPrint } from "react-to-print";
import { Autocomplete, Tooltip } from "@mui/material";
import PrintReport from "../../../../components/common/printReport/PrintReport";
import FileExcel from "../../../../components/common/excelSheet/FileExcel";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import Pagination from "../../../../components/common/Pagination";
import moment from "moment";


export default function SahayApplicationMasterReport() {
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const location = PagesIndex.useLocation();

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [excel, setExcel] = useState([]);
  const [filterSubSahayName, setFilterSubSahayName] = useState("");
  const [filter, setFilter] = useState("");
  const [filterSubSahay, setFilterSubSahay] = useState("");
  const [filterSahay, setFilterSahay] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [sahayTypeList, setSahayTypeList] = useState([]);
  const [sahaySubTypeList, setSahaySubTypeList] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [rowPerPage, setRowPerPage] = useState("25");
  const [filterReportData, setFilterReportData] = useState([]);
  const [filterFamilyIncome, setFilterFamilyIncome] = useState("");
  const [filterElectricityBill, setFilterElectricityBill] = useState("");
  const [selectDateData, setSelectDateData] = useState("");

  // Print Reports
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    if (month >= 4) {
      return `${year} - ${year + 1}`;
    } else {
      return `${year - 1} - ${year}`;
    }
  };

  useEffect(() => {
    const filters = {
      FID: filter,
      Year: filterYear,
      SahayName: filterSahay,
      SubSahayName: filterSubSahay,
      // familyIncome: filterFamilyIncome,
      // electricityBill: filterElectricityBill,
      // applicationReceiveDate: selectDateData,
    };

    const filterData = data?.filter((ele) => {
      if (Object.values(filters).some(Boolean)) {
        return Object.entries(filters).every(([key, value]) => {
          if (!value) return true;
          return ele[key] == value;
        });
      } else {
        return true;
      }
    });
    setFilterReportData(filterData);
  }, [
    filter,
    filterYear,
    filterSahay,
    filterSubSahay,
    // filterElectricityBill,
    // filterFamilyIncome,
    // selectDateData,
  ]);

  useEffect(() => {
    setSearchedData(filterReportData);
  }, [filterReportData]);

  const fileName = "Application Master Report CSV";
useEffect(() => {
  const customHeadings = filterReportData?.map((item) => ({
    "Year": item?.Year || "-",
    "Applicant ID": item?.applicationId || "-",
    "FID": item?.FID || "-",
    "Applicant Name": item?.ApplicantName || "-",
    "Sahay Category": item?.SahayName || "-",
    "Sub Sahay Category": item?.SubSahayName || "-",
    "Form Filing Date": item?.formFillingDate || "-",
    "Staff Status": item?.newStatusColumn || "-",
    "Staff Remark": item?.remark || "-",
    "Committee Status": item?.committeeStatus || "-",
    "Committee Remark": item?.committeeRemark || "-",
    "Applied Amount": item?.SahayAmount || "-",
    "Approved Amount": item?.ApproveAmount || "-",
    "Approval Date": item?.committeeApprovalDate || "-",
    "Disbursed Amount": item?.disbursedAmount || "-",
    "Disbursed Date": item?.disbursedDate
      ? moment(item?.disbursedDate).format("YYYY-MM-DD")
      : "-",
    "Balance Amount":
      item?.ApproveAmount && item?.disbursedAmount
        ? Number(item?.ApproveAmount) - Number(item?.disbursedAmount)
        : "-",
  }));

  setExcel(customHeadings);
}, [filterReportData]);

  const requestSearch = (searched) => {
    if (!searched) return setSearchedData(filterReportData);

    setSearchedData(
      filterReportData?.filter(
        (item) =>
          item?.ApplicantName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase())
      )
    );
  };

  //get Sub sahay list
  const getSahaySubTypeData = async (id) => {
    dispatch(getSahaySubTypeList(id)).then((res) => {
      if (res?.payload) {
        setSahaySubTypeList(res?.payload);
      } else {
        setSahaySubTypeList([]);
      }
    });
  };
  //Sahay Type list
  const fetchSahayTypeList = () => {
    dispatch(getSahayTypeList()).then((res) => {
      setSahayTypeList(res?.payload);
    });
  };

  useEffect(() => {
    fetchSahayTypeList();
    getSahaySubTypeData();
  }, []);

  useEffect(() => {
    setLoader(true)
    getSahayApplicationMasterReport().then((res) => {
      // console.log("res")
      if (res?.status == 200) {
        setData(res?.data);
        setLoader(false);
      }
      setLoader(false);
    });
  }, []);

  useEffect(() => {
    if (data.length > 0 && !filterYear) {
      const current = getCurrentFinancialYear();
      const hasCurrent = data.some((item) => item.Year === current);
      // console.log("hasCurrent",hasCurrent,current)
      if (hasCurrent) {
        setFilterYear(current);
      } else {
        const uniqueYears = [...new Set(data.map((item) => item.Year))].sort(
          (a, b) => parseInt(b.split("-")[0]) - parseInt(a.split("-")[0])
        );
        // console.log("uniqueYears",uniqueYears)
        setFilterYear(uniqueYears[0] || "");
      }
    }
  }, [data, filterYear]);

  //#region start view sahay application

  const handleSahayApplicationView = (viewdata) => {
    const updatedViewData = {
      ...viewdata,
      familyId: viewdata?.FID,
      prevRoute: location?.pathname,
    };
    navigate(`/${rollData}/sahay-report-view`, { state: updatedViewData });
  };

  //#region end view sahay application

  const { rollPermissionData } = useSelector((state) => state.admin);
  const rollPermissionNameData =
    rollPermissionData?.findData?.parentRoleName?.toLowerCase();

  if (
    rollPermissionData?.permissionArray?.includes(
      "Application Master Report_view"
    ) ||
    rollPermissionNameData === "admin"
  ) {
  } else {
    navigate(`/${rollData}/sahay-application`);
  }

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box className="title-header">
                <Index.Box className="title-header-flex res-title-header-flex">
                  <Index.Box className="plus-hidden-show-mobile">
                    <Index.Box className="title-main">
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="page-title"
                      >
                        Application Master Report
                      </Index.Typography>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="table-list">
                <Index.Box className="grid-row sahay-multiple-main">
                  <Index.Box sx={{ width: 1 }} className="grid-main">
                    <Index.Box
                      display="grid"
                      className="multiple-row"
                      gridTemplateColumns="repeat(12, 1fr)"
                      gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                    >
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 4",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <PagesIndex.Search
                            className="search sahay-multiple-search"
                            onChange={(e) => requestSearch(e.target.value)}
                          >
                            <PagesIndex.StyledInputBase placeholder="Search" />
                          </PagesIndex.Search>
                        </Index.Box>
                      </Index.Box>

                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 4",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            className="multiple-autocomplet-control"
                            id="combo-box-demo"
                            options={data || []}
                            getOptionLabel={(option) => option?.FID?.toString()}
                            onChange={(value, newvalue) => {
                              setFilter(newvalue?.FID);
                            }}
                            filterOptions={(options, { inputValue }) => {
                              const inputLowerCase = inputValue?.toLowerCase();
                              const uniqueFamilyId = new Set();
                              return options?.filter((option) => {
                                const familyId =
                                  option?.FID?.toString()?.toLowerCase();
                                // Check unique
                                if (uniqueFamilyId?.has(familyId)) {
                                  return false;
                                }
                                // Check search
                                if (familyId?.includes(inputLowerCase)) {
                                  uniqueFamilyId?.add(familyId);
                                  return true;
                                }
                                return false;
                              });
                            }}
                            renderInput={(params) => (
                              <Index.TextField {...params} label="Fid" />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={sahayTypeList || []}
                            getOptionLabel={(option) => option?.Sahay_category}
                            onChange={(value, newvalue) => {
                              setSahaySubTypeList([]);
                              setFilterSubSahay("");
                              // setFilter("");
                              setFilterSahay(newvalue?.Sahay_category);
                              getSahaySubTypeData(newvalue?.Id);
                            }}
                            renderInput={(params) => (
                              <Index.TextField {...params} label="Sahay Category" />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={sahaySubTypeList}
                            getOptionLabel={(option) => option?.SahayName}
                            onChange={(value, newvalue) => {
                              setFilterSubSahay(newvalue?.SahayName);
                            }}
                            value={
                              sahaySubTypeList &&
                              sahaySubTypeList.length > 0 &&
                              filterSubSahay
                                ? sahaySubTypeList.find(
                                    (item) => item.SahayName === filterSubSahay
                                  )
                                : null
                            }
                            renderInput={(params) => (
                              <Index.TextField
                                {...params}
                                label="Sub Sahay Category"
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={data || []}
                            getOptionLabel={(option) => option?.Year}
                            value={
                              data.find((item) => item.Year === filterYear) ||
                              null
                            }
                            onChange={(value, newvalue) => {
                              setFilterYear(newvalue?.Year);
                            }}
                            filterOptions={(options, { inputValue }) => {
                              const inputLowerCase = inputValue?.toLowerCase();
                              const uniqueYear = new Set();
                              const filteredOptions = options?.filter(
                                (option) => {
                                  const Year =
                                    option?.Year?.toString()?.toLowerCase();
                          
                                  if (uniqueYear?.has(Year)) {
                                    return false;
                                  }
                                  if (Year?.includes(inputLowerCase)) {
                                    uniqueYear?.add(Year);
                                    return true;
                                  }
                                  return false;
                                }
                              );
                              // Sort years in ascending order
                              return filteredOptions.sort((a, b) => {
                                const yearA = parseInt(a.Year.split("-")[0]);
                                const yearB = parseInt(b.Year.split("-")[0]);
                                return yearA - yearB;
                              });
                            }}
                            renderInput={(params) => (
                              <Index.TextField {...params} label="Year" />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                      {filterReportData?.length > 0 &&
                        searchedData?.length > 0 && (
                          <>
                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 3",
                                lg: "span 3",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="sahay-multiple-input-main">
                                <Index.Box
                                  Box
                                  className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                >
                                  <FileExcel
                                    apiData={excel}
                                    fileName={fileName}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>

                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 3",
                                lg: "span 3",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="sahay-multiple-input-main">
                                <Index.Box
                                  Box
                                  sx={{ justifyContent: "end" }}
                                  className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                >
                                  <Index.Button onClick={handlePrint}>
                                    Print
                                  </Index.Button>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </>
                        )}
                    </Index.Box>
                  </Index.Box>
                </Index.Box>

                <Index.TableContainer
                  sx={{ maxHeight: 180 }}
                  component={Index.Paper}
                  className="table-container user-master-container scroll-table"
                >
                  <Index.Table
                    stickyHeader
                    aria-label="sticky table"
                    className="table-design-main barge-table multiple-tablelist-table"
                  >
                    <Index.TableHead className="user-master-head">
                      <Index.TableRow className="user-master-tr">
                        <Index.TableCell className="user-master-th">
                          Year
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Applicant ID
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          FID
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Sahay Category
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Sub Sahay Category
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Form Filing Date
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Staff Status
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Staff Remark
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Committee Status
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Committee Remark
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Applied Amount
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Approved Amount
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Approval Date
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Disbursed Amount
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Disbursed Date
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Balance Amount
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableHead>
                    <Index.TableBody className="user-master-tbody">
                      {pageData?.length &&
                      (filter ||
                        filterYear ||
                        filterSahay ||
                        filterSubSahay ||
                        filterElectricityBill ||
                        filterFamilyIncome ||
                        selectDateData) ? (
                        pageData
                          ?.map((data, index) => {
                            return (
                              <Index.TableRow
                                className="user-master-tr"
                                key={index}
                                // onClick={() => handleSahayApplicationView(data)}
                                // sx={{ cursor: "pointer" }}
                              >
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-role-name">
                                    {data?.Year || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-details-name">
                                    {data?.applicationId || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-details-name">
                                    {data?.FID || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-details-name">
                                    {data?.ApplicantName || "-"}
                                  </Index.Box>
                                </Index.TableCell>

                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-email-name">
                                    {data?.SahayName || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-email-name">
                                    {data?.SubSahayName || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.formFillingDate || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.newStatusColumn || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Tooltip title={data?.remark || "-"} arrow>
                                    <Index.Box className="user-number-name">
                                      {data?.remark?.length > 20
                                        ? `${data.remark.substring(0, 20)}...`
                                        : data?.remark || "-"}
                                    </Index.Box>
                                  </Tooltip>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.committeeStatus || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Tooltip
                                    title={data?.committeeRemark || "-"}
                                    arrow
                                  >
                                    <Index.Box className="user-number-name">
                                      {data?.committeeRemark?.length > 20
                                        ? `${data.committeeRemark.substring(
                                            0,
                                            20
                                          )}...`
                                        : data?.committeeRemark || "-"}
                                    </Index.Box>
                                  </Tooltip>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.SahayAmount || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.ApproveAmount || "-"}
                                  </Index.Box>
                                </Index.TableCell>

                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.committeeApprovalDate || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.disbursedAmount || "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.disbursedDate
                                      ? moment(data?.disbursedDate).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell className="user-master-td">
                                  <Index.Box className="user-number-name">
                                    {data?.ApproveAmount &&
                                    data?.disbursedAmount
                                      ? Number(data?.ApproveAmount) -
                                        Number(data?.disbursedAmount)
                                      : "-"}
                                  </Index.Box>
                                </Index.TableCell>
                              </Index.TableRow>
                            );
                          })
                      ) : (
                        <PagesIndex.NoRecordFound colSpan={17} />
                      )}
                    </Index.TableBody>
                  </Index.Table>
                </Index.TableContainer>
                {filterReportData?.length > 0 && searchedData?.length > 0 && (
                  <Index.Box className="multiple-total-text-main">
                    <Index.Typography className="multiple-total-text">
                      Total Amount :
                      {searchedData.length > 0 &&
                        searchedData?.reduce((acc, curr) => {
                          let total;
                          total = acc + curr?.SahayAmount;
                          return total;
                        }, 0)}
                    </Index.Typography>
                  </Index.Box>
                )}

                {/* {filterReportData?.length > 0 && searchedData?.length > 0 && ( */}
                <Index.Box className="pagination-design flex-end">
                  <RowPerPageDropdown
                    rowPerPage={rowPerPage}
                    setRowPerPage={setRowPerPage}
                  />
                  <Index.Stack spacing={2}>
                    <Pagination
                      fetchData={searchedData}
                      setPageData={setPageData}
                      pageData={pageData}
                      rowPerPage={rowPerPage}
                    />
                  </Index.Stack>
                </Index.Box>
                {/* )} */}
                <Index.Box sx={{ display: "none" }}>
                  <PrintReport
                    componentRef={componentRef}
                    tableData={excel}
                    reportName={[{ type: "ApplicationMasterReport" }]}
                  />
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </>
      )}
    </>
  );
}
